import React from 'react';
import { Modal } from 'antd';
import { Field, Form, Formik } from 'formik';
import { AntInput } from 'components/Formik-AntdFields/CreateAntdField';
import { companyContactValidation } from 'scenes/Settings/utils/validate';
import { IContact, ISettings } from 'services/store/types/settings/Settings';

const initValues = {
  name: '',
  email: '',
  phone: '',
  description: '',
};

interface IProps {
  closeModal: () => void;
  updateSettings: (data: Partial<ISettings>) => Promise<any>;
  contact: IContact[];
}

const AddCompanyContactModal: React.FC<IProps> = ({
  closeModal,
  contact,
  updateSettings,
}) => {
  const handleSubmit = async (data: IContact) => {
    await updateSettings({ contact: [...contact, data] });
    closeModal();
  };

  return (
    <Modal
      title="Kontakt"
      destroyOnClose
      visible
      onCancel={closeModal}
      maskClosable={false}
      okButtonProps={{
        form: 'companyContactEditId',
        htmlType: 'submit',
        disabled: false,
      }}
    >
      <Formik
        validationSchema={companyContactValidation}
        onSubmit={handleSubmit}
        initialValues={initValues}
      >
        {(props) => {
          return (
            <Form
              noValidate
              id="companyContactEditId"
              onSubmit={props.handleSubmit}
            >
              <Field
                component={AntInput}
                name="name"
                type="text"
                placeholder="Nazwa"
                validate={props.errors.name}
                submitCount={props.submitCount}
                hasFeedback
              />
              <Field
                component={AntInput}
                name="email"
                type="text"
                placeholder="E-mail"
                validate={props.errors.email}
                submitCount={props.submitCount}
                hasFeedback
              />
              <Field
                component={AntInput}
                name="phone"
                type="text"
                placeholder="Nr telefonu"
                validate={props.errors.phone}
                submitCount={props.submitCount}
                hasFeedback
              />
              <Field
                component={AntInput}
                name="description"
                type="text"
                placeholder="Opis"
                validate={props.errors.description}
                submitCount={props.submitCount}
                hasFeedback
              />
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default AddCompanyContactModal;
